import React from 'react';
import { Link } from 'react-router-dom';
import {
    Bar,
    BarChart,
    CartesianGrid,
    Cell,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from 'recharts';
import './Charts.css';

const barChart = (props) => {
    const colors = ['#1abc9c', '#3498db', '#9b59b6', '#f53b57', '#34495e',]
    if (props.data.length) {
        return (
            <div style={{ width: '100%', height: 450 }}>
                <h3 className="text-center">{props.title}</h3>
                <ul className="product-name-list">
                    {
                        props.data.map((item, i) => {
                            return <li key={i} ><Link to={`/products/${item.id}`}><span style={{ backgroundColor: colors[i] }}></span>{item.name}</Link></li>
                        })
                    }
                </ul>
                <ResponsiveContainer width="100%" height={320}>
                    <BarChart
                        data={props.data}
                        margin={{
                            top: 5, right: 10, left: 10, bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        {/* <Legend /> */}
                        {/* <Legend verticalAlign="top" height={36}/> */}
                        <Bar name={props.labelName} maxBarSize={50} minPointSize={5} dataKey={props.key1} fill={props.key1Color || "#8884d8"} label={{ position: 'top' }} >
                            {
                                props.data.map((entry, index) => <Cell key={`cell-${index}`} minPointSize={5} fill={colors[index % colors.length]} />)
                            }
                        </Bar>
                        {/* <Bar dataKey={props.key2} fill={props.key2Color || "#82ca9d"}  label={{ position: 'top' }}/> */}
                    </BarChart>
                </ResponsiveContainer>
            </div>
        );
    } else {
        return (
            <div className="alert bg-warning mt-5 text-dark text-center">
                <h3>No Sales for the current date</h3>
            </div>
        )
    }

}

export default barChart;